module.exports = __webpack_public_path__ + "static/media/non_ulip.be2bab93.mp3";